var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var BaseHotTableToursView = require('../../../../include/_js/hot-table/BaseHotTableToursView');

        var HotTableToursView = function (_BaseHotTableToursVie) {
            _inherits(HotTableToursView, _BaseHotTableToursVie);

            function HotTableToursView(params) {
                _classCallCheck(this, HotTableToursView);

                // Пока сюда вытащил
                var _this = _possibleConstructorReturn(this, (HotTableToursView.__proto__ || Object.getPrototypeOf(HotTableToursView)).call(this, params));

                _this.attachCommonDesktopHandlers();
                HotTableToursView.attachHotelModalHandlers();
                _this.attachSortHandlers();
                _this.attachFilterHandlers();
                return _this;
            }

            /**
             * @param {{}} params
             */


            _createClass(HotTableToursView, [{
                key: "defineMap",
                value: function defineMap(params) {
                    var _this2 = this;

                    // TODO: add option to BaseHotTableToursView configuration to disable this method call
                    var mapContainer = document.getElementById('hot-table-map-container');
                    if (!mapContainer) {
                        return;
                    }
                    this.mapInstance = new ToursMap('#hot-table-map-container');
                    this.mapInstance.forceHotTableDataSource();
                    this.mapInstance.setPopoverContentTemplate(params.mapPopoverTemplate);
                    this.mapInstance.setIcons(window.toursMapIcons);
                    this.mapInstance.setOnMarkerClickCallback(function (tour) {
                        window.showHotelInfoModal(tour.id);
                    });

                    $('.hot-table-content-switch').on('click', function (e) {
                        var $selfBtn = $(e.currentTarget);
                        if ($selfBtn.data('type') === 'list') {
                            $selfBtn.data('type', 'map');
                            $selfBtn.text('Отели списком');
                            _this2.elems.$hotTable.addClass('hidden');
                            _this2.mapInstance.$mapContainer.removeClass('hidden');
                            _this2.mapInstance.onMapBlockShown();

                            _this2.$sortButtonsWrapper.addClass('buttons-hidden');
                        } else {
                            $selfBtn.data('type', 'list');
                            $selfBtn.text('Отели на карте');
                            _this2.elems.$hotTable.removeClass('hidden');
                            _this2.mapInstance.$mapContainer.addClass('hidden');
                            _this2.$sortButtonsWrapper.removeClass('buttons-hidden');
                        }
                    });
                }
            }, {
                key: "attachCommonDesktopHandlers",
                value: function attachCommonDesktopHandlers() {
                    this.elems.$hotTable.on('focus', '.price-tour-credit', function () {
                        $(this).find('.price-credit-item.hidden').remove();
                    });
                }
            }, {
                key: "attachFilterHandlers",
                value: function attachFilterHandlers() {
                    $(".filterTblHeader").on("click", function () {
                        $(this).toggleClass("filterTblHeader__closed");
                        $(this).next().slideToggle(200);
                    });
                }
            }, {
                key: "attachSortHandlers",
                value: function attachSortHandlers() {
                    var _this3 = this;

                    $('.hot-table-sort-button', this.$sortButtonsWrapper).on('click', function (e) {
                        var $selfButton = $(e.currentTarget);
                        if ($selfButton.hasClass('active')) {
                            return;
                        }
                        var sortParams = _this3.getSortParamsByField($selfButton.data('type'));
                        _this3.setSortStat(sortParams);

                        _this3.$sortButtonsWrapper.find('.active').removeClass('active');
                        $selfButton.addClass('active');

                        _this3.elems.$hotTable.hotTable('makeResort', sortParams.field, sortParams.direction);
                        _this3.slideToTableTop();
                        _this3.lazyLoadImages();
                    });
                }
            }, {
                key: "renderFilterData",


                /**
                 * Переопределяем renderFilterData
                 * @param {Object} hotTableInstance виджет hotTable
                 * @private
                 */
                value: function renderFilterData(hotTableInstance) {
                    // Рисуем суперфильтр
                    var filters = hotTableInstance.options['filters'];
                    for (var filterKey in filters) {
                        if (!filters.hasOwnProperty(filterKey)) {
                            continue;
                        }
                        var filterHtml = '';
                        var filter = filters[filterKey];
                        var $f = $("#filterTbl_" + filterKey);

                        for (var valueKey in filter.values) {
                            var filterParams = filter.values[valueKey];
                            filterHtml += hotTableInstance._renderFilterItem(filterKey, filterParams);
                            filterParams['rendered'] = true;
                        }

                        $f.find('.values').html(filterHtml);
                    }

                    hotTableInstance._setOption('filters', filters);
                }
            }, {
                key: "$sortButtonsWrapper",
                get: function get() {
                    return $('.hot-table-header-buttons ul');
                }
            }], [{
                key: "attachHotelModalHandlers",
                value: function attachHotelModalHandlers() {
                    function initOfficeMaps() {
                        $('#hotel_buy .city-map').each(function () {
                            var $self = $(this);
                            var officeId = $self.data('office-id');
                            var map_id = 'office-' + officeId + '-' + $self.data('tour-id');
                            var map = new OfficeSchemeMap(map_id, $self.data('office-lon'), $self.data('office-lat'), $self.data('office-hint'));
                            map.init();
                        });
                    }
                    // При открытии закладки с картой в модальном окне инициализация карты
                    $('body').on('shown.bs.tab', '#hotTabs1 a[data-toggle="tab"]', function (e) {
                        var $target = $(e.target);
                        switch ($target.attr("href")) {
                            case '#hotel_map':
                                var $tabContent = $($target.attr("href")).find('#hotel_map2');
                                if (window.ToursMap) {
                                    var toursMap = $tabContent.data('map-instance');
                                    if (!toursMap) {
                                        toursMap = new ToursMap($tabContent.data('map-container'));
                                        toursMap.setIcons(window.toursMapIcons);
                                        toursMap.forceHotTableDataSource();
                                        toursMap.setOnMarkerClickCallback(function (tour) {
                                            window.showHotelInfoModal(tour.id);
                                        });
                                        toursMap.setDefaultHotel({
                                            id: $tabContent.data('hotel'),
                                            coordinates: {
                                                lat: $tabContent.data('lat'),
                                                lng: $tabContent.data('lng')
                                            }
                                        });
                                        toursMap.setPopoverContentTemplate($tabContent.find('.js-map-popover-template').html());
                                        // save map instance in data attribute
                                        $tabContent.data('map-instance', toursMap);
                                    }
                                    toursMap.onMapBlockShown();
                                } else {
                                    $tabContent.html('<div class="alert alert-info">Не удалось загрузить карту отеля</div>');
                                }
                                break;
                            case '#hotel_buy':
                                HotTableToursView.loadShortId();

                                // Инициализация карт офисов
                                var haveMap = $target.data('map-init');
                                if (haveMap !== 1) {
                                    $target.data('map-init', 1);
                                    initOfficeMaps();
                                }
                                break;
                        }
                    });
                }
            }, {
                key: "loadShortId",
                value: function loadShortId() {
                    var $sourceTourId = $(".hotel-info_tabs .js-tour-id-source");
                    if ($sourceTourId.length && $sourceTourId.data('load') !== 1) {
                        $sourceTourId.data('load', 1);

                        var selector = ".hotel-info_tabs .js-short-tour-id";
                        var realId = $sourceTourId.text();
                        window.utils.getShortTourId(realId, selector);
                    }
                }
            }]);

            return HotTableToursView;
        }(BaseHotTableToursView);

        module.exports = HotTableToursView;
    }, { "../../../../include/_js/hot-table/BaseHotTableToursView": 3 }], 2: [function (require, module, exports) {
        var HotTableToursView = require('../../../../include/hot-table/_js/HotTableToursView');
        window.HotTableToursView = HotTableToursView;

        $(document).ready(function () {
            var $hotWrapperElem = $('.hotoffer-content-wrapper'),
                hotContentHeight = $('.hotoffer-content').height(),
                hotWrapperHeight = $hotWrapperElem.height(),
                link = '';
            if (!$hotWrapperElem.hasClass('no-collapse') && hotContentHeight > hotWrapperHeight) {
                link = '<a href="#" class="show-hotoffer-content">Показать всё описание</a>';
                $hotWrapperElem.after(link);
            }

            $('.foldToggle').click(function (e) {
                e.preventDefault();
                var t = $(this),
                    rowsWrapper = $('.hotoffers-same-rows[data-group="' + t.data('group') + '"]');
                if (t.hasClass('ht-open')) {
                    t.html(t.data('title')).removeClass('ht-open');
                    rowsWrapper.addClass('hide');
                } else {
                    t.data('title', t.html()).html('<span>Скрыть</span>').addClass('ht-open');
                    rowsWrapper.removeClass('hide');
                }
            });

            $('body').on('click', '.show-hotoffer-content', function (e) {
                e.preventDefault();
                $('.hotoffer-content-wrapper').css({ 'max-height': 'none' });
                $(this).remove();
            }).on('click', '.toggle-hot-offer', function (e) {
                e.preventDefault();
                var element = $(this).prev('.info');
                element.css('max-height', 'none');
                $(this).hide();
            });

            $('.images img, .bigImg').on('error', function () {
                // $(this).attr('src', $(this).attr('src'));
            });
        });
    }, { "../../../../include/hot-table/_js/HotTableToursView": 1 }], 3: [function (require, module, exports) {
        var ToursStorage = require('./ToursStorage');

        var EVENT_ON_AFTER_FILTER = 'onAfterFilter';

        var BaseHotTableToursView = function () {
            function BaseHotTableToursView(params) {
                _classCallCheck(this, BaseHotTableToursView);

                this.mobile = 'mobile' in params ? params.mobile : false;

                /**
                 * @type {ToursMap|null}
                 */
                this.mapInstance = null;
                this.defineMap(params);

                this.toursLoadRequest = null;

                this.toursOnFirstPage = 'toursOnFirstPage' in params ? params.toursOnFirstPage : null;
                this.toursPerPage = 'toursPerPage' in params ? params.toursPerPage : 20;

                /**
                 * @type {string|null}
                 */
                this.hotTableSelector = 'hotTableSelector' in params ? params.hotTableSelector : null;
                /**
                 * Наименование страны поиска
                 * @type {string|null}
                 */
                this.sortFieldType = 'sortFieldType' in params ? params.sortFieldType : 'price_asc';
                this.paginationType = 'paginationType' in params ? params.paginationType : 'pagination';
                this.groupResults = 'groupResults' in params ? params.groupResults : true;
                this.isUseAjaxHotTableData = 'isUseAjaxHotTableData' in params ? params.isUseAjaxHotTableData : false;
                this.preRenderTours = 'preRenderTours' in params ? params.preRenderTours : true;
                this.loadToursLink = 'loadToursLink' in params ? params.loadToursLink : '';
                this.defaultTours = 'defaultTours' in params ? params.defaultTours : [];
                this.slideToSelector = 'slideToSelector' in params ? params.slideToSelector : '';
                this.instantFilter = 'instantFilter' in params ? params.instantFilter : true;
                this.findMoreOnFilter = 'findMoreOnFilter' in params ? params.findMoreOnFilter : false;
                this.creditSettings = 'creditSettings' in params ? params.creditSettings : null;

                /**
                 * Шаблон для строки
                 * @type {string}
                 */
                this.rowTemplate = 'rowTemplate' in params ? params.rowTemplate : '';
                /**
                 * Шаблон для строки
                 * @type {string}
                 */
                this.rowTemplateWithPriceForTour = 'rowTemplateWithPriceForTour' in params ? params.rowTemplateWithPriceForTour : '';
                /**
                 * Шаблоны
                 * @type {{help: {tel: string, mail: string, include: string}, cntText: string, same: string, sameHeaders: string}}
                 */
                this.templates = 'templates' in params ? params.templates : {
                    help: {
                        tel: '',
                        mail: '',
                        include: ''
                    },
                    cntText: '({{cnt}})',
                    same: '',
                    sameHeaders: '',
                    sameHotels: 'Еще туры в отель'
                };
                this.rangeBound = parseInt(params.rangeBound, 10) ? params.rangeBound : 10000;
                this.curSign = params.curSign || '₸';
                this.curSigns = {
                    kzt: '₸',
                    usd: '$',
                    eur: '<span class="light_eur">€</span>'
                };

                this.isHotTableReady = false;
                this.elems = {
                    $hotTable: $(this.hotTableSelector),
                    $pagination: 'paginationSelector' in params ? $(params.paginationSelector) : null,
                    $loading: 'loadingToursSelector' in params ? $(params.loadingToursSelector) : null,
                    $tourCount: 'toursCountSelector' in params ? $(params.toursCountSelector) : null
                };
                this.elems.$hotTable.data('hotTableToursViewObject', this);
                this.toursStorage = new ToursStorage(this.elems.$hotTable);
                this.restoreSameToursForTourId = 'restoreSameToursForTourId' in params ? params.restoreSameToursForTourId : '';

                this.state = {
                    allowSlideOnAfterFilter: true,
                    allowLazyLoadImages: true
                };
                this.timers = {
                    onAfterApplyFilter: 0
                };

                this.externalListeners = {};
                this.externalListeners[EVENT_ON_AFTER_FILTER] = [];

                this.init();
            }

            /**
             * @param {string} eventType
             * @param {Function} callback
             */


            _createClass(BaseHotTableToursView, [{
                key: "bind",
                value: function bind(eventType, callback) {
                    if (this.externalListeners.hasOwnProperty(eventType) && typeof callback === 'function') {
                        this.externalListeners[eventType].push(callback);
                    } else {
                        console.error('unknown event type OR invalid callback type');
                    }
                }
                /**
                 * @param {string} eventType
                 */

            }, {
                key: "dispatchEvent",
                value: function dispatchEvent(eventType) {
                    if (this.externalListeners[eventType].length) {
                        this.externalListeners[eventType].forEach(function (callback) {
                            callback();
                        });
                    }
                }
            }, {
                key: "init",
                value: function init() {
                    this.initHotTable();
                    if (this.preRenderTours) {
                        this.loadTours();
                    }
                    window.setScriptReadyEventOnce('hotTableToursViewInstanceReady');
                }

                /**
                 * Подменяет
                 */

            }, {
                key: "setRowTemplateWithPriceForTour",
                value: function setRowTemplateWithPriceForTour() {
                    if (this.isHotTableReady) {
                        if (this.rowTemplateWithPriceForTour !== '') {
                            this.elems.$hotTable.hotTable('option', 'template', this.rowTemplateWithPriceForTour);
                        }
                        return true;
                    }
                    return false;
                }
            }, {
                key: "setTourViewUrlParams",
                value: function setTourViewUrlParams(urlParams) {
                    this.elems.$hotTable.hotTable('setTourViewUrlParams', urlParams);
                }

                /**
                 * redefined in mobile/desktop instance
                 * @param {{}} params
                 */

            }, {
                key: "defineMap",
                value: function defineMap(params) {}

                /**
                 * @param {string} filterType
                 * @param {mixed} value
                 */

            }, {
                key: "toggleFilterValue",
                value: function toggleFilterValue(filterType, value) {
                    var filterValuesWrapSelector = this.mobile ? '#filter-values__' + filterType : '#filterTbl_' + filterType;
                    var $target = $(filterValuesWrapSelector + ' input[value="' + value + '"]');
                    if ($target.length) {
                        // Если фильтр отрисован
                        $target.trigger('click');
                    }
                }

                /**
                 * Применить фильтр
                 */

            }, {
                key: "applyFilters",
                value: function applyFilters() {
                    var _this4 = this;

                    if (this.instantFilter) return false;
                    // Если фильтр применяется без действия пользователя - запретить скрол onAfterFilter
                    this.state.allowSlideOnAfterFilter = false;
                    if (this.findMoreOnFilter) {
                        // При применении фильров снаружи - поиск не запускется
                        this.elems.$hotTable.hotTable('option', 'findMoreOnFilter', false);
                    }
                    this.elems.$hotTable.hotTable('applyFilters');

                    // Возвращаем настройки после применения фильтра
                    clearTimeout(this.timers.onAfterApplyFilter);
                    this.timers.onAfterApplyFilter = setTimeout(function () {
                        _this4.elems.$hotTable.hotTable('option', 'findMoreOnFilter', _this4.findMoreOnFilter);
                        _this4.state.allowSlideOnAfterFilter = true;
                    });

                    return true;
                }
            }, {
                key: "initHotTable",
                value: function initHotTable() {
                    var _this5 = this;

                    var renderFilterDataCallback = this.renderFilterData;

                    // use default sort direction from hot-table for now
                    var sortParams = this.getSortParamsByField(this.sortFieldType);
                    this.elems.$hotTable.hotTable({
                        mobile: this.mobile,
                        isTable: !this.mobile,
                        refreshFilterDesc: this.mobile,
                        sortable: this.mobile, // TODO: add to desktop
                        showHelpLine: true,
                        template: this.rowTemplate,
                        templates: this.templates,
                        group: this.groupResults,
                        groupOnlyBest: false,
                        editDate: false,
                        makeWrap: false,
                        firstPageBaseCountView: this.toursOnFirstPage ? this.toursOnFirstPage : null,
                        baseCountView: this.toursPerPage,
                        addRowsInsert: false,
                        startWithEmpty: true,
                        instantFilter: this.instantFilter,
                        findMoreOnFilter: this.findMoreOnFilter,
                        toggleFilter: !this.mobile,
                        sortBy: sortParams.field,
                        useHash: true,
                        debug: false,
                        elem_filter: this.mobile ? $('#hot-table-filters-wrapper') : $('#resultsFilter'),
                        paginationType: this.paginationType,
                        b: {
                            start: '{{',
                            end: '}}'
                        },
                        texts: {
                            same: ['тур', 'тура', 'туров']
                        },
                        elem_page: this.elems.$pagination,
                        rangeBound: Number(this.rangeBound),
                        curSign: this.curSign,
                        images_path: {
                            star: this.mobile ? '/img/icons/star.svg' : '/img/icons/star.png',
                            star_muted: this.mobile ? '/img/icons/star.svg' : '/img/icons/star_muted.png'
                        },
                        mutedStar: this.mobile,
                        onPageClick: function onPageClick() {
                            _this5.slideToTableTop();
                            _this5.lazyLoadImages();
                        },
                        renderFilter2: function renderFilter2() {
                            return '';
                        },
                        /**
                         * @param {Object} that виджет hotTable
                         */
                        renderFilterData: function renderFilterData(that) {
                            renderFilterDataCallback(that);
                        },
                        onClientRefreshWidget: function onClientRefreshWidget(event, data) {},
                        onBeforeResort: function onBeforeResort(event, data) {
                            _this5.elems.$hotTable.trigger('hotTableToursView.onBeforeResort');
                        },
                        onAfterFilter: function onAfterFilter() {
                            if (_this5.mobile) {
                                if (_this5.state.allowSlideOnAfterFilter) {
                                    _this5.slideToTableTop();
                                    _this5.lazyLoadImages();
                                }
                            }
                            _this5.dispatchEvent(EVENT_ON_AFTER_FILTER);
                        },
                        onAfterRefresh: function onAfterRefresh(event, data) {
                            var showDiscountsPerBaseCountView = 5;
                            var len = false;
                            if (data.visibleRows !== undefined) {
                                len = data.visibleRows.length;
                            }
                            if (len) {
                                var discounts = [];
                                var discountCnt = 0;
                                var visibleCnt = 0;
                                var discountValue = 0;

                                // 5 максимальных скидок из порции
                                for (var i = 0; i < len; i++) {
                                    var rowId = data.visibleRows[i][0];
                                    var row = hotTableData[rowId];
                                    discountValue = parseInt(row.values.discount, 10) || 0;
                                    if (row && discountValue) {
                                        discounts.push({
                                            id: rowId,
                                            discount: discountValue
                                        });
                                        discountCnt++;
                                    }
                                    // Если хоть у одно видимого предложения есть скидка ...
                                    if (discountCnt && ((i + 1) % _this5.toursPerPage === 0 || i === len - 1)) {
                                        discounts.sort(function (a, b) {
                                            return b.discount - a.discount;
                                        });
                                        for (var j = 0; j < discountCnt; j++) {
                                            if (visibleCnt < showDiscountsPerBaseCountView) {
                                                hotTableData[discounts[j].id].values.showDiscount = true;
                                                visibleCnt++;
                                            } else {
                                                hotTableData[discounts[j].id].values.showDiscount = false;
                                            }
                                        }
                                        discounts = [];
                                        discountCnt = 0;
                                        visibleCnt = 0;
                                    }
                                }
                                _this5.elems.$hotTable.hotTable('updateElementsInViewport', '.main-row.visible');
                            }
                        },
                        firstAddEvent: function firstAddEvent() {
                            if (_this5.slideToSelector !== '') {
                                _this5.slideTo(_this5.slideToSelector);
                            }
                            $('.hflt_body__empty').hide();
                            _this5.elems.$pagination.removeClass('hidden');
                            _this5.hideLoading();
                        },
                        onAfterAddRows: function onAfterAddRows(event) {
                            _this5.updateToursCount(_this5.getTotalCount());
                            if (_this5.findMoreOnFilter) {
                                _this5.hideLoading();
                            }
                            if (_this5.state.allowLazyLoadImages) {
                                _this5.lazyLoadImages();
                            }
                            window.tracking.callTrackingRefresh();
                        }
                    });
                    if (this.creditSettings) {
                        this.elems.$hotTable.hotTable('option', 'creditSettings', this.creditSettings);
                    }

                    this.isHotTableReady = true;
                }

                /**
                 * @return {number}
                 */

            }, {
                key: "getTotalCount",
                value: function getTotalCount() {
                    return this.elems.$hotTable.hotTable('getTotalCount');
                }
            }, {
                key: "slideToTableTop",
                value: function slideToTableTop() {
                    // mobile site header height
                    var offsetDiff = this.mobile ? 65 : 60;
                    this.slideTo(this.hotTableSelector, 600, -offsetDiff);
                }
            }, {
                key: "lazyLoadImages",
                value: function lazyLoadImages() {
                    if (!this.mobile) {
                        return; // lazy loading пока только в мобильной версии
                    }
                    this.elems.$hotTable.find('.js-hot-table-row.visible .tour-gallery-item-lazy').each(function () {
                        var $item = $(this);
                        $item.css('backgroundImage', 'url(' + $item.data('src') + ')');
                        $item.removeClass('tour-gallery-item-lazy');
                        $item.removeAttr('data-src');
                    });
                }

                /**
                 * @param {string} selector
                 * @param {number} [duration]
                 * @param {number} [offsetDiff]
                 */

            }, {
                key: "slideTo",
                value: function slideTo(selector, duration, offsetDiff) {
                    // В мобильной версии шапка fixed. Добавлям отступ
                    if (typeof offsetDiff === 'undefined') {
                        offsetDiff = this.mobile ? -65 : 0;
                    }
                    if (typeof duration === 'undefined') {
                        duration = this.mobile ? 500 : 600;
                    }
                    $('html, body').animate({
                        scrollTop: $(selector).offset().top + offsetDiff
                    }, duration);
                }

                /**
                 * @param {Object} hotTableInstance виджет hotTable
                 * @private
                 */

            }, {
                key: "renderFilterData",
                value: function renderFilterData(hotTableInstance) {}
            }, {
                key: "loadTours",
                value: function loadTours() {
                    var _this6 = this;

                    if (this.isUseAjaxHotTableData) {
                        if (this.loadToursLink === '') {
                            console.error('required option missed');
                            return;
                        }
                        this.loadToursRemote(this.loadToursLink, true, function () {
                            _this6.elems.$hotTable.trigger('hotTableToursView.onFirstLoad');
                        }, false);
                    } else {
                        this.clear();
                        if (this.restoreSameToursForTourId) {
                            var item = this.toursStorage.getByTourId(this.restoreSameToursForTourId);
                            if (item !== null) {
                                for (var i in item.tours) {
                                    // Уже есть в defaultTours
                                    var tour = item.tours[i];
                                    if (tour.id !== this.restoreSameToursForTourId) {
                                        this.defaultTours.push(tour);
                                    }
                                }
                            } else {
                                console.log('storage not exist');
                            }
                        }
                        this.addRows(this.defaultTours);
                        this.elems.$hotTable.trigger('hotTableToursView.onFirstLoad');
                        this.lazyLoadImages();
                    }
                }

                /**
                 * @param {number} count
                 */

            }, {
                key: "updateToursCount",
                value: function updateToursCount(count) {
                    if (this.elems.$tourCount === null) {
                        return false;
                    }
                    this.elems.$tourCount.html(count);
                }

                /**
                 * Показывает слой наложения над выдачей.
                 * @param hideTitle
                 */

            }, {
                key: "showOverlay",
                value: function showOverlay() {
                    var hideTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    this.hideNotFoundBlock();
                    this.elems.$hotTable.find('.hot-table-overlay').removeClass('hidden');
                    if (hideTitle) {
                        this.elems.$hotTable.find('.tours-title').addClass('hidden');
                    }
                }
            }, {
                key: "hideOverlay",
                value: function hideOverlay() {
                    this.elems.$hotTable.find('.hot-table-overlay').addClass('hidden');
                    this.elems.$hotTable.find('.tours-title').removeClass('hidden');
                }
            }, {
                key: "showLoading",
                value: function showLoading() {
                    var asOverlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    this.hideNotFoundBlock();
                    this.elems.$loading.removeClass('hidden');
                    this.elems.$hotTable.addClass('loading' + (asOverlay ? ' loading-overlay' : ' loading-inline'));
                    this.elems.$hotTable.removeClass(asOverlay ? 'loading-inline' : 'loading-overlay');
                    if (asOverlay) {
                        $('body').addClass('hot-table-loading-as-overlay');
                    }
                    var loadBgImages = this.mobile && asOverlay;
                    window.utils.loadImages(this.elems.$hotTable.find('.search-loading'), true, loadBgImages);
                    if (asOverlay) {
                        this.state.allowLazyLoadImages = false;
                    }
                }
            }, {
                key: "hideLoading",
                value: function hideLoading() {
                    var hideOverlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    this.elems.$loading.addClass('hidden');
                    this.elems.$hotTable.removeClass('loading' + (hideOverlay ? ' loading-overlay' : ' loading-inline'));
                    if (hideOverlay) {
                        $('body').removeClass('hot-table-loading-as-overlay');
                    }
                    if (hideOverlay) {
                        this.state.allowLazyLoadImages = true;
                        this.lazyLoadImages();
                    }
                }
            }, {
                key: "abortLoadToursRemoteRequest",
                value: function abortLoadToursRemoteRequest() {
                    if (this.toursLoadRequest) {
                        this.toursLoadRequest.abort();
                    }
                }

                /**
                 * @param {string} link
                 * @param {boolean} runClear
                 * @param {Function|null} onLoad
                 * @param {boolean} showOverlay
                 */

            }, {
                key: "loadToursRemote",
                value: function loadToursRemote(link, runClear) {
                    var _this7 = this;

                    var onLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    var showOverlay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

                    this.abortLoadToursRemoteRequest();
                    this.showLoading(showOverlay);
                    this.toursLoadRequest = $.get(link).done(function (data) {
                        if (runClear) {
                            _this7.clear();
                        }
                        if (!data.rows || !data.rows.length) {
                            _this7.showNotFoundBlock();
                        } else {
                            _this7.addRows(data.rows);
                        }
                        if (typeof onLoad === 'function') {
                            onLoad(data.count);
                        }
                        if (showOverlay) {
                            _this7.hideLoading(showOverlay);
                        } else {
                            _this7.lazyLoadImages();
                        }
                    }).fail(function (event, textStatus) {
                        // abort вызывается вручную, при этом, как правило,
                        // далее следует либо другой запрос, либо начинается поиск.
                        // Поэтому при abort показывать этот блок не нужно
                        if (textStatus !== 'abort') {
                            _this7.showNotFoundBlock();
                        }
                    });
                }
            }, {
                key: "addRows",
                value: function addRows(rows) {
                    this.elems.$hotTable.hotTable('addRows', rows);
                }
            }, {
                key: "clear",
                value: function clear() {
                    var changeHtml = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    this.updateToursCount(0);
                    this.elems.$hotTable.hotTable('clear', changeHtml, options);
                }
            }, {
                key: "adjustValueToRangeBound",
                value: function adjustValueToRangeBound(price) {
                    if (!price) {
                        return 0;
                    }
                    return Math.floor(price / this.rangeBound) * this.rangeBound;
                }
            }, {
                key: "hideNotFoundBlock",
                value: function hideNotFoundBlock() {
                    this.elems.$hotTable.show();
                    $('.not-found-tours-block').addClass('hidden');
                }
            }, {
                key: "showNotFoundBlock",
                value: function showNotFoundBlock() {
                    this.elems.$hotTable.hide();
                    $('.not-found-tours-block').removeClass('hidden');
                }

                /**
                 * @param {string} field
                 * @return {boolean}
                 * @private
                 */

            }, {
                key: "_isValidSortField",
                value: function _isValidSortField(field) {
                    return ['price_asc', 'price_desc', 'popularity', 'rating'].indexOf(field) !== -1;
                }

                /**
                 * @param {string} field
                 * @return {{field: string, direction: string, statKey: string}}
                 */

            }, {
                key: "getSortParamsByField",
                value: function getSortParamsByField(field) {
                    var sortField = 'price';
                    var sortDirection = 'asc';
                    var statKeys = {
                        price: 'hotTable.priceSortButtonClick',
                        popularity: 'hotTable.popularitySortButtonClick',
                        rating: 'hotTable.ratingSortButtonClick'
                    };

                    if (this._isValidSortField(field)) {
                        if (['popularity', 'rating'].indexOf(field) !== -1) {
                            sortField = field;
                            sortDirection = 'desc';
                        } else if (field === 'price_desc') {
                            sortDirection = 'desc';
                        }
                    } else {
                        console.error('unknown sort field "%s"', field);
                    }

                    return {
                        field: sortField,
                        direction: sortDirection,
                        statKey: statKeys[sortField] || ''
                    };
                }
            }, {
                key: "getHotTableFilterSelectedValues",
                value: function getHotTableFilterSelectedValues() {
                    return this.elems.$hotTable.hotTable('getAppliedFilterValues');
                }

                /**
                 * @param {{
                 *  statKey: string,
                 *  field: string,
                 *  direction: string
                 * }} sortParams
                 */

            }, {
                key: "setSortStat",
                value: function setSortStat(sortParams) {
                    if (!this._sortTypeChanged) {
                        this._sortTypeChanged = {};
                    }

                    // 1 event на каждый тип сортировки
                    if (!this._sortTypeChanged.hasOwnProperty(sortParams.field) && sortParams.statKey) {
                        window.tracking.stat(sortParams.statKey, {
                            info: sortParams.direction
                        });
                    }
                    this._sortTypeChanged[sortParams.field] = 1;
                }
            }]);

            return BaseHotTableToursView;
        }();

        module.exports = BaseHotTableToursView;
    }, { "./ToursStorage": 4 }], 4: [function (require, module, exports) {
        /**
         * Сохранение туров чтобы можно было показать Еще N туров для нераспознанных отелей, так как для них мы не можем
         * запустить поиск туров на странице тура.
         * Нельзя использовать SessionStorage, так как он уникален для каждой вкладке
         */
        var ToursStorage = function () {
            function ToursStorage($resultTable) {
                _classCallCheck(this, ToursStorage);

                this.KEY = 'SameTours';
                this.TIME_LIMIT = 3600000;
                this.$resultTable = $resultTable;
            }

            _createClass(ToursStorage, [{
                key: "save",
                value: function save(mainTourId) {
                    if (!this._isLocalStorageSupport()) {
                        return;
                    }
                    var mainTour = this.$resultTable.hotTable('getTour', "r" + mainTourId);
                    if (mainTour === null) {
                        console.log('no mainTour');
                        return;
                    }
                    if (mainTour.values.hotel_id) {
                        // сохраняем только у нераспознанных отелей,
                        // так как у распознанных мы найдем туры обычным поиском
                        console.log('tour have hotel_id');
                        return;
                    }
                    var tours = this._getFromTable(mainTourId);
                    if (tours.length === 0) {
                        return;
                    }
                    console.log(mainTourId, tours);
                    var allTours = this._getFromStorage();
                    allTours[mainTourId] = {
                        tours: tours,
                        time: +new Date()
                    };
                    var value = JSON.stringify(allTours);
                    localStorage.setItem(this.KEY, value);
                }

                /**
                 * @param mainTourId
                 * @return {null|array}
                 */

            }, {
                key: "getByTourId",
                value: function getByTourId(mainTourId) {
                    var allTours = this._getFromStorage();
                    if (allTours.hasOwnProperty(mainTourId)) {
                        return allTours[mainTourId];
                    }
                    return null;
                }
            }, {
                key: "_getFromStorage",
                value: function _getFromStorage() {
                    if (!this._isLocalStorageSupport()) {
                        return {};
                    }
                    var result = localStorage.getItem(this.KEY);
                    if (result === null) {
                        return {};
                    }
                    var allTours = JSON.parse(result);
                    return this._rotate(allTours);
                }

                /**
                 * @param mainTourId
                 * @return {Array}
                 * @private
                 */

            }, {
                key: "_getFromTable",
                value: function _getFromTable(mainTourId) {
                    var tours = [];
                    var sameTours = this.$resultTable.hotTable('getSameHotels', "r" + mainTourId);
                    sameTours = ["r" + mainTourId].concat(sameTours);
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = sameTours[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var tourId = _step.value;

                            var tour = this.$resultTable.hotTable('getTour', tourId);
                            if (tour !== null) {
                                // TODO передаем не все параметры, так как надо экономить место в localStorage
                                tours.push(tour.values);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    return tours;
                }
            }, {
                key: "_isLocalStorageSupport",
                value: function _isLocalStorageSupport() {
                    return window.utils.isLocalStorageSupported;
                }
            }, {
                key: "_rotate",
                value: function _rotate(data) {
                    // если прошло больше часа, дропаем
                    var newList = {};
                    var now = +new Date();
                    for (var tourId in data) {
                        if (tourId in data) {
                            var tours = data[tourId];
                            if (now - tours.time < this.TIME_LIMIT) {
                                newList[tourId] = tours;
                            } else {
                                console.log("drop " + tourId, tours, now);
                            }
                        }
                    }
                    return newList;
                }
            }]);

            return ToursStorage;
        }();

        module.exports = ToursStorage;
    }, {}] }, {}, [2]);